import { v4 as uuidv4 } from "uuid";
import { useAuth } from "@/App";
import { AssignmentProps } from "@/interfaces/assignment_types";
import { ClientProps } from "@/interfaces/client_types";
import { EmployeeProps } from "@/interfaces/employee_type";
import { InvoiceProps } from "@/interfaces/invoices_types";
import { PointOfContactProps } from "@/interfaces/point-of-contact_types";
import { ProjectProps } from "@/interfaces/project_types";
import { RFIProps } from "@/interfaces/rfi_types";
import { SubmittalProps } from "@/interfaces/submittal_types";
import { TaskProps } from "@/interfaces/tasks_types";
import { GenericTable } from "../GenericTable";
import { IGenericTable } from "../Interfaces/IGenericTable";
import {
	ASSIGNMENT_COLUMNS,
	CAS_PROJECT_COLUMNS,
	CLIENT_COLUMNS,
	CLIENT_PROJECT_COLUMNS,
	EMPLOYEE_COLUMNS,
	FINANCE_PROJECT_COLUMNS,
	INVOICE_COLUMNS,
	MINI_CA_PROJECT_COLUMNS,
	MINI_PROJECT_COLUMNS,
	POINT_OF_CONTACT_COLUMNS,
	PROJECT_COLUMNS,
	RFI_COLUMNS,
	SUBMITTAL_COLUMNS,
	TASK_COLUMNS,
} from "../Options/ModelColumns";
import {
	ASSIGNMENT_FILTER_OPTIONS,
	CLIENT_FILTER_OPTIONS,
	EMPLOYEE_FILTER_OPTIONS,
	INVOICE_FILTER_OPTIONS,
	POINT_OF_CONTACT_FILTER_OPTIONS,
	PROJECT_FILTER_OPTIONS,
	RFI_FILTER_OPTIONS,
	SUBMITTAL_FILTER_OPTIONS,
	TASK_FILTER_OPTIONS,
} from "../Options/ModelOptions";
import { GenericTableClass } from "./GenericTableClass";

export class ProjectTable extends GenericTableClass<ProjectProps> {
	constructor(props: IGenericTable<ProjectProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		return (
			<GenericTable<ProjectProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={0}
				filterOptions={PROJECT_FILTER_OPTIONS}
				columns={PROJECT_COLUMNS}
				starting_filters={[
					{
						id: uuidv4(),
						filterBy: "project_name",
						filterText: "",
						filterType: "string",
					},
				]}
			/>
		);
	}
}

export class YourProjectsTable extends GenericTableClass<ProjectProps> {
	constructor(props: IGenericTable<ProjectProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		const { user } = useAuth();
		return (
			<GenericTable<ProjectProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={0}
				filterOptions={PROJECT_FILTER_OPTIONS}
				columns={PROJECT_COLUMNS}
				starting_filters={[
					{
						id: uuidv4(),
						filterBy: "project_name",
						filterText: "",
						filterType: "string",
					},
					{
						id: uuidv4(),
						filterBy: "manager__name",
						filterText: user?.name ?? "",
						filterType: "string",
					},
					{
						id: uuidv4(),
						filterBy: "status",
						filterText: "Active",
						filterType: "string",
					},
				]}
			/>
		);
	}
}

export class MiniProjectTable extends GenericTableClass<ProjectProps> {
	constructor(props: IGenericTable<ProjectProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		return (
			<GenericTable<ProjectProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={0}
				filterOptions={PROJECT_FILTER_OPTIONS}
				columns={MINI_PROJECT_COLUMNS}
				show_arrow={this.show_arrow}
				show_filters={this.show_filters}
				starting_filters={[
					{
						id: uuidv4(),
						filterBy: "project_name",
						filterText: "",
						filterType: "string",
					},
				]}
			/>
		);
	}
}

export class MiniCASProjectTable extends GenericTableClass<ProjectProps> {
	constructor(props: IGenericTable<ProjectProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		return (
			<GenericTable<ProjectProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={0}
				filterOptions={PROJECT_FILTER_OPTIONS}
				columns={MINI_CA_PROJECT_COLUMNS}
				show_arrow={this.show_arrow}
				show_filters={this.show_filters}
				starting_filters={[
					{
						id: uuidv4(),
						filterBy: "project_name",
						filterText: "",
						filterType: "string",
					},
					{
						id: uuidv4(),
						filterBy: "construction_admin_services",
						filterText: "Yes",
						filterType: "string",
					},
				]}
			/>
		);
	}
}

export class ClientProjectTable extends GenericTableClass<ProjectProps> {
	constructor(props: IGenericTable<ProjectProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		return (
			<GenericTable<ProjectProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={0}
				filterOptions={PROJECT_FILTER_OPTIONS}
				columns={CLIENT_PROJECT_COLUMNS}
				show_arrow={this.show_arrow}
				starting_filters={[
					{
						id: uuidv4(),
						filterBy: "project_name",
						filterText: "",
						filterType: "string",
					},
				]}
			/>
		);
	}
}

export class FinanceProjectTable extends GenericTableClass<ProjectProps> {
	constructor(props: IGenericTable<ProjectProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		return (
			<GenericTable<ProjectProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={0}
				filterOptions={PROJECT_FILTER_OPTIONS}
				columns={FINANCE_PROJECT_COLUMNS}
				starting_filters={[
					{
						id: uuidv4(),
						filterBy: "project_name",
						filterText: "",
						filterType: "string",
					},
					{
						id: uuidv4(),
						filterBy: "manager__name",
						filterText: "",
						filterType: "string",
					},
				]}
			/>
		);
	}
}

export class CASProjectTable extends GenericTableClass<ProjectProps> {
	constructor(props: IGenericTable<ProjectProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		return (
			<GenericTable<ProjectProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={0}
				filterOptions={PROJECT_FILTER_OPTIONS}
				columns={CAS_PROJECT_COLUMNS}
				starting_filters={[
					{
						id: uuidv4(),
						filterBy: "project_name",
						filterText: "",
						filterType: "string",
					},
					{
						id: uuidv4(),
						filterBy: "construction_admin_services",
						filterText: "Yes",
						filterType: "string",
					},
				]}
			/>
		);
	}
}

export class TaskTable extends GenericTableClass<TaskProps> {
	constructor(props: IGenericTable<TaskProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		return (
			<GenericTable<TaskProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={0}
				filterOptions={TASK_FILTER_OPTIONS}
				columns={TASK_COLUMNS}
				starting_filters={[
					{
						id: uuidv4(),
						filterBy: "status",
						filterText: "Active",
						filterType: "string",
					},
					{
						id: uuidv4(),
						filterBy: "project_id__project_name",
						filterText: "",
						filterType: "string",
					},
					{
						id: uuidv4(),
						filterBy: "assigned_to__name",
						filterText: "",
						filterType: "string",
					},
				]}
			/>
		);
	}
}

export class YourTasksTable extends GenericTableClass<TaskProps> {
	constructor(props: IGenericTable<TaskProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		const { user } = useAuth();
		return (
			<GenericTable<TaskProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={0}
				filterOptions={TASK_FILTER_OPTIONS}
				columns={TASK_COLUMNS}
				starting_filters={[
					{
						id: uuidv4(),
						filterBy: "project_id__project_name",
						filterText: "",
						filterType: "string",
					},
					{
						id: uuidv4(),
						filterBy: "status",
						filterText: "Active",
						filterType: "string",
					},
					{
						id: uuidv4(),
						filterBy: "assigned_to__name",
						filterText: user?.name ?? "",
						filterType: "string",
					},
				]}
			/>
		);
	}
}

export class AssignmentTable extends GenericTableClass<AssignmentProps> {
	constructor(props: IGenericTable<AssignmentProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		return (
			<GenericTable<AssignmentProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={0}
				filterOptions={ASSIGNMENT_FILTER_OPTIONS}
				columns={ASSIGNMENT_COLUMNS}
			/>
		);
	}
}

export class SubmittalTable extends GenericTableClass<SubmittalProps> {
	constructor(props: IGenericTable<SubmittalProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		return (
			<GenericTable<SubmittalProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={1}
				filterOptions={SUBMITTAL_FILTER_OPTIONS}
				columns={SUBMITTAL_COLUMNS}
				starting_filters={[
					{
						id: uuidv4(),
						filterBy: "project__project_name",
						filterText: "",
						filterType: "string",
					},
				]}
			/>
		);
	}
}

export class YourSubmittalsTable extends GenericTableClass<SubmittalProps> {
	constructor(props: IGenericTable<SubmittalProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		const { user } = useAuth();
		return (
			<GenericTable<SubmittalProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={1}
				filterOptions={SUBMITTAL_FILTER_OPTIONS}
				columns={SUBMITTAL_COLUMNS}
				starting_filters={[
					{
						id: uuidv4(),
						filterBy: "project__project_name",
						filterText: "",
						filterType: "string",
					},
					{
						id: uuidv4(),
						filterBy: "assigned_to__name",
						filterText: user?.name ?? "",
						filterType: "string",
					},
				]}
			/>
		);
	}
}

export class RFITable extends GenericTableClass<RFIProps> {
	constructor(props: IGenericTable<RFIProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		return (
			<GenericTable<RFIProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={1}
				filterOptions={RFI_FILTER_OPTIONS}
				columns={RFI_COLUMNS}
				starting_filters={[
					{
						id: uuidv4(),
						filterBy: "project__project_name",
						filterText: "",
						filterType: "string",
					},
				]}
			/>
		);
	}
}

export class YourRFIsTable extends GenericTableClass<RFIProps> {
	constructor(props: IGenericTable<RFIProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		const { user } = useAuth();
		return (
			<GenericTable<RFIProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={1}
				filterOptions={RFI_FILTER_OPTIONS}
				columns={RFI_COLUMNS}
				starting_filters={[
					{
						id: uuidv4(),
						filterBy: "project__project_name",
						filterText: "",
						filterType: "string",
					},
					{
						id: uuidv4(),
						filterBy: "assigned_to__name",
						filterText: user?.name ?? "",
						filterType: "string",
					},
				]}
			/>
		);
	}
}

export class InvoiceTable extends GenericTableClass<InvoiceProps> {
	constructor(props: IGenericTable<InvoiceProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		return (
			<GenericTable<InvoiceProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={0}
				filterOptions={INVOICE_FILTER_OPTIONS}
				columns={INVOICE_COLUMNS}
				starting_filters={[
					{
						id: uuidv4(),
						filterBy: "project_id__project_name",
						filterText: "",
						filterType: "string",
					},
				]}
			/>
		);
	}
}

export class EmployeeTable extends GenericTableClass<EmployeeProps> {
	constructor(props: IGenericTable<EmployeeProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		return (
			<GenericTable<EmployeeProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={0}
				filterOptions={EMPLOYEE_FILTER_OPTIONS}
				columns={EMPLOYEE_COLUMNS}
			/>
		);
	}
}

export class ClientTable extends GenericTableClass<ClientProps> {
	constructor(props: IGenericTable<ClientProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		return (
			<GenericTable<ClientProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={0}
				filterOptions={CLIENT_FILTER_OPTIONS}
				columns={CLIENT_COLUMNS}
			/>
		);
	}
}

export class PointOfContactTable extends GenericTableClass<PointOfContactProps> {
	constructor(props: IGenericTable<PointOfContactProps>) {
		super(props);
	}

	RenderTable(): React.ReactNode {
		return (
			<GenericTable<PointOfContactProps>
				expandableRowComponent={this.expandableRowComponent}
				model_name={this.model_name}
				defaultSortFieldIndex={0}
				filterOptions={POINT_OF_CONTACT_FILTER_OPTIONS}
				columns={POINT_OF_CONTACT_COLUMNS}
			/>
		);
	}
}
